<div class="av-view-wrapper">
  <div
    #avViewContainer
    class="av-view-container"
    [style.background-color]="backgroundColor()"
    [style.width]="viewportStyles().width"
    [style.height]="viewportStyles().height">
    @if (hasAuthError()) {
      <div class="error-container">
        <div class="error-icon">&#9888;</div>
        <div class="error-title">Connection Failed</div>
        <div class="error-message">Please restart your Soundshape device to reconnect.</div>
      </div>
    } @else if (isLoading()) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">Connecting...</div>
      </div>
    } @else {
      <app-subtitle-box
        [subtitleBoxSettings]="currentSubtitleSettings()"
        [enableEdit]="enableEdit"
        [messages]="messages()"
        [transcriptLanguage]="transcriptLanguage()"
        [applyTranslationDelay]="shouldApplyTranslationDelay()"
        [transformScale]="scaleFactor()"
        [dragBoundary]="avViewContainer"
        (onSubtitleBoxChange)="updateSubtitleBox($event)"></app-subtitle-box>
    }
  </div>
</div>